// import './tailwindcss/app.css'; not use this because has a setting in jsconfig.json
import 'assets/tailwindcss/app.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import HomePage from 'pages/HomePage';
import Details from 'pages/Details';
import Cart from 'pages/Cart';
import Congratulation from 'pages/Congratulation';
import notFound from 'pages/notFound';

import Provider from 'helpers/hooks/useGlobalContext';

function App() {
  return (
    <Provider>
      {/* <div className="App"> */}
      <Router>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/categories/:idcat" component={Details} />
          <Route path="/categories/:idcat/products/:idp" component={Details} />
          <Route path="/cart" component={Cart} />
          <Route path="/success" component={Congratulation} />
          <Route path="*" component={notFound} />
        </Switch>
      </Router>
      {/* </div> */}
    </Provider>
  );
}

export default App;
